import { render, staticRenderFns } from "./review_4.vue?vue&type=template&id=bb451050&scoped=true&"
import script from "./review_4.vue?vue&type=script&lang=js&"
export * from "./review_4.vue?vue&type=script&lang=js&"
import style0 from "./review_4.vue?vue&type=style&index=0&id=bb451050&scoped=true&lang=css&"
import style1 from "./review_4.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb451050",
  null
  
)

export default component.exports